import { Pipe, PipeTransform } from '@angular/core';
import { getRolaReprezentantaOrganizacjiLabel } from '../enums/rola-reprezentanta-organizacji.enum';

@Pipe({
  name: 'organizationRepresentativeRoleLabel',
  standalone: true,
})
export class OrganizationRepresentativeRoleLabelPipe
  implements PipeTransform
{
  transform(value: string | null | undefined): string {
    return getRolaReprezentantaOrganizacjiLabel(value);
  }
}
